import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useEffect, useState } from 'react';

import { GB_FEATURES } from 'dpl/shared/constants/gb_features';
import { isMobileUA } from 'dpl/shared/utils';

const IS_MOBILE_UA = isMobileUA();

export default function useStickyFilters({ container } = {}) {
  const isFeatureOn = useFeatureIsOn(
    GB_FEATURES.EXP_STICKY_EXPOSED_FILTERS_MOBILE
  );

  const [isContainerStuck, setIsContainerStuck] = useState(false);

  const hasMobileStickyFiltersEnabled = IS_MOBILE_UA && isFeatureOn;

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return null;
    if (!hasMobileStickyFiltersEnabled || !container) return null;

    const observer = new window.IntersectionObserver(
      ([e]) => setIsContainerStuck(e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(container);

    return () => {
      observer.unobserve(container);
    };
  }, [container]);

  return {
    hasMobileStickyFiltersEnabled,
    isContainerStuck
  };
}
